module.exports = __webpack_public_path__ + "static/media/weld@2x.14742011.jpg";